module.exports = __webpack_public_path__ + "static/media/gif_動畫_0913.48db3408.gif";